
export let games = [
    {
        away: "Cedar",
        date: "3/7",
        time: "4:00pm",
        place: "Home",
        score_lca: 5,
        score_away: 0,
        jv: "11 x 0"
    },

    {
        away: "Green Canyon",
        date: "3/9",
        time: "4:00pm",
        place: "Away",
        score_lca: 3,
        score_away: 1,
        jv: "0 x 0"
    },

    {
        away: "Mountain Crest",
        date: "3/14",
        time: "3:00pm",
        place: "Away",
        score_lca: 3,
        score_away: 0,
        jv: "4 x 0"
    },

    {
        away: "Bear River",
        date: "3/16",
        time: "7:00pm",
        place: "Away",
        score_lca: 8,
        score_away: 0,
        jv: "6 x 0"
    },

    {
        away: "Ogden",
        date: "3/18",
        time: "6:30pm",
        place: "Home",
        score_lca: 2,
        score_away: 0,
        jv: "1 x 1"
    },

    {
        away: "Mountain Ridge",
        date: "3/21",
        time: "3:30pm",
        place: "Away",
        score_lca: 1,
        score_away: 0,
        jv: "1 x 0"
    },

    {
        away: "Bonneville",
        date: "3/23",
        time: "3:30pm",
        place: "Away",
        score_lca: null,
        score_away: null
    },

    {
        away: "Ridgeline",
        date: "4/1",
        time: "3:00pm",
        place: "Away",
        score_lca: 2,
        score_away: 3,
        jv: "2 x 1"
    },

    {
        away: "Uintah",
        date: "4/4",
        time: "4:00pm",
        place: "Home",
        score_lca: null,
        score_away: null
    },

    {
        away: "Waterford",
        date: "4/6",
        time: "4:00pm",
        place: "Away",
        score_lca: null,
        score_away: null
    },


    {
        away: "Rowland Hall",
        date: "4/14",
        time: "4:00pm",
        place: "Away",
        score_lca: 8,
        score_away: 0,
        jv: "8 x 0"
    },

    {
        away: "Alta",
        date: "4/18",
        time: "3:30pm",
        place: "Away",
        score_lca: 3,
        score_away: 0,
        jv: "1 x 1"
    },

    {
        away: "Morgan",
        date: "4/20",
        time: "3:30pm",
        place: "Away",
        score_lca: 1,
        score_away: 0,
        jv: "2 x 0"
    },

    {
        away: "Salt Lake Academy",
        date: "4/25",
        time: "3:30pm",
        place: "Away",
        score_lca: null,
        score_away: null
    },


]